import { render, staticRenderFns } from "./bottomFieldInfoRender.vue?vue&type=template&id=22e7fc16&scoped=true"
import script from "./bottomFieldInfoRender.vue?vue&type=script&lang=js"
export * from "./bottomFieldInfoRender.vue?vue&type=script&lang=js"
import style0 from "./bottomFieldInfoRender.vue?vue&type=style&index=0&id=22e7fc16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e7fc16",
  null
  
)

export default component.exports